<template>
    <div class="animated fadeIn">
        <table class="kgr-table kgr-table--compact kgr-table--block table-groups table-employees kgr-table--striped printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Name') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Geschlecht') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Rasse') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Rasse Spezialisierung') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Wurfdatum') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Todesdatum') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Chipnummer') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Zuchtbuchnummer') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="dog in dogs"
                    :key="dog.id"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        <a
                            :href="`/backend/clubs/dogs/${dog.id}/show`"
                            class="kgr-link kgr-link--unobtrusive"
                        >
                            {{ dog.name }}
                        </a>
                    </td>
                    <td class="kgr-table__cell">
                        {{ dog.gender !== null ? $t(dog.gender) : $t('gender.u') }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ dog.breed ? dog.breed.label : '' }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ dog.breedSpecialization ? dog.breedSpecialization.label : '' }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ dog.dateOfBirth }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ dog.dateOfDeath }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ dog.chipNumber }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ dog.breedingBookNumber }}
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                        <a
                            :href="`/backend/clubs/dogs/${dog.id}/edit`"
                            class="kgr-table__action"
                        >
                            <kgr-icon icon-class="edit" />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Icon from '../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        dogs: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
